import type { ReportValueFormat } from '../types/monthlyClubReport';

const DOLLAR = String.fromCharCode(36);

export function formatReportValue(value: number, format: ReportValueFormat): string {
  if (format === 'currency') return DOLLAR + Math.round(value).toLocaleString('en-AU');
  if (format === 'currencyCents') return DOLLAR + value.toLocaleString('en-AU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  if (format === 'percent') return `${value.toFixed(1)}%`;
  return value.toLocaleString('en-AU');
}

// "+17", "-4", "+$14,020", "-$3,720"
export function formatReportDelta(delta: number, format: ReportValueFormat): string {
  const sign = delta > 0 ? '+' : delta < 0 ? '-' : '';
  return sign + formatReportValue(Math.abs(delta), format);
}

// Whole-number shares that always add to 100 (largest remainder)
export function sharesOf(values: number[]): number[] {
  const total = values.reduce((sum, v) => sum + v, 0);
  if (total === 0) return values.map(() => 0);
  const raw = values.map(v => v / total * 100);
  const floored = raw.map(Math.floor);
  let remaining = 100 - floored.reduce((sum, v) => sum + v, 0);
  const order = raw.map((v, i) => ({
    i,
    rem: v - Math.floor(v)
  })).sort((a, b) => b.rem - a.rem);
  for (const { i } of order) {
    if (remaining <= 0) break;
    floored[i] += 1;
    remaining -= 1;
  }
  return floored;
}
